import React, { Component } from 'react';
import {
  USER_ROLE_ADMIN,
} from 'common/userRoles';

import { SCREEN_ID_ADMIN_FINANCE_DEPOSITS } from 'client/constants/screenIds';
import allowedRoles from 'client/helpers/allowedRoles';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import SrPage from 'client/components/SrPage';
import SrH1 from 'client/components/SrH1';
import SrDataTableDeposits from 'client/components/financeAdmin/SrDataTableDeposits';

@withTransitionHook
@allowedRoles({
  roles: [
    USER_ROLE_ADMIN,
  ],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_ADMIN_FINANCE_DEPOSITS)
@withScrollToTop
class FinancesDepositsPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Finances - Deposits | Sunroom Rentals',
  })

  render() {
    return (
      <SrPage
        navbarProps={{
          redirectLogoTo: '/admin',
          backButtonLink: '/admin',
        }}
      >
        <div className='width-90'>
          <SrH1>Deposits</SrH1>
          <SrDataTableDeposits />
        </div>
      </SrPage>
    );
  }
}

FinancesDepositsPage.displayName = 'FinancesDepositsPage';

export default FinancesDepositsPage;
